mutation updatePersonFields($entityId: ID!, $input: UpdatePersonFieldsInput!) {
  person: updatePersonFields(entityId: $entityId, input: $input) {
    aggregateId
    jobTitle
    country
    city
    state
    address
    company
    timezone
    email
    bands
    directWorkforce
    fte
  }
}
